var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C10.6569 7.5 12 6.15685 12 4.5C12 2.84315 10.6569 1.5 9 1.5C7.34315 1.5 6 2.84315 6 4.5C6 6.15685 7.34315 7.5 9 7.5Z",
    stroke: "#FA41AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.75C14.7427 6.75 15.75 5.91 15.75 4.875C15.75 3.84 14.7427 3 13.5 3M4.5 6.75C3.25725 6.75 2.25 5.91 2.25 4.875C2.25 3.84 3.25725 3 4.5 3",
    stroke: "#FA41AA",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C11.4853 15.75 13.5 14.4069 13.5 12.75C13.5 11.0931 11.4853 9.75 9 9.75C6.51472 9.75 4.5 11.0931 4.5 12.75C4.5 14.4069 6.51472 15.75 9 15.75Z",
    stroke: "#FA41AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.25C16.3155 13.9613 17.25 13.2308 17.25 12.375C17.25 11.5192 16.3155 10.7887 15 10.5M3 14.25C1.6845 13.9613 0.75 13.2308 0.75 12.375C0.75 11.5192 1.6845 10.7887 3 10.5",
    stroke: "#FA41AA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrIcon);
export default __webpack_public_path__ + "static/media/HRIcon.eee696ca5796b5094d99d7982ed9c846.svg";
export { ForwardRef as ReactComponent };